import React from 'react';
import ReservationActionCell from './ReservationActionCell';
import BookButton from './BookButton';
import ApprovalStatus from './ApprovalStatus';
import { BusinessTypes } from '../../../constants/Enums';

const QuotesGridColumnDefinitions = (
    refreshCampaign,
    readOnly = false,
    getQuotes,
    reservationTimeValues,
    scrolling,
    creditStatusWorkflowId = undefined,
    reservationWorkflowId = undefined,
    preBookingWorkflowId = undefined,
    bookingWorkflowId = undefined,
    discountApprovalWorkflowId = undefined,
    isCampaignModified,
    updateCampaign,
    activeBookingRequest,
    updateActiveRequest,
    canApprove = false,
    campaignApprovalTeam = undefined,
    businessType,
    validateBooking,
    campaign,
    billingAccountCreditDetails,
    isCampaignBurst,
    activeRequest,
    discountRequest,
    dealDiscounts = [],
    onDiscountRequestApproval,
    isUsingDynamicWorkflow,
    valuePotRequest,
    valuePotApprovalWorkflowId
) => {
    const columns = [
        {
            displayOrder: 1,
            headerName: '',
            field: 'id',
            type: 'hidden',
            hideInColumnFilter: true
        },
        {
            displayOrder: 2,
            headerName: window.translate('Actions'),
            field: 'custom',
            type: 'action',
            style: { width: 80, maxWidth: 80, textAlign: 'left' },
            hideInColumnFilter: true,
            showInList: true,
            sortable: false,
            component: (
                <ReservationActionCell
                    refreshCampaign={refreshCampaign}
                    readOnly={readOnly}
                    reservationTimeValues={reservationTimeValues}
                    getQuotes={getQuotes}
                    scrolling={scrolling}
                    workflowId={reservationWorkflowId}
                />
            )
        },
        {
            displayOrder: 3,
            headerName: '',
            field: 'delete',
            type: 'action',
            width: 50,
            hideInColumnFilter: true,
            showInList: true,
            sortable: false
        },
        {
            displayOrder: 4,
            headerName: window.translate('Name'),
            field: 'name',
            type: readOnly ? 'text' : 'input',
            width: 'auto',
            hideInColumnFilter: true,
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 5,
            headerName: window.translate('Version'),
            field: 'versionName',
            type: 'text',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 6,
            headerName: window.translate('Stations'),
            field: 'stationCount',
            type: 'text',
            width: 70,
            style: { width: 70, textAlign: 'right' },
            showInList: true,
            sortable: true,
            sortOrder: ''
        },

        {
            displayOrder: 8,
            headerName: window.translate('Amount'),
            field: 'amount',
            type: 'currency',
            width: 'auto',
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 9,
            headerName: window.translate('Start Date'),
            field: 'startDate',
            type: 'date',
            width: 130,
            style: { width: 130, textAlign: 'left' },
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 10,
            headerName: window.translate('End Date'),
            field: 'endDate',
            type: 'date',
            width: 130,
            style: { width: 130, textAlign: 'left' },
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 11,
            headerName: window.translate('Create Date'),
            field: 'createdDate',
            type: 'datetime',
            width: 120,
            style: { textAlign: 'left' },
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 12,
            headerName: window.translate('Quote Valid'),
            field: 'validToDate',
            type: 'datetime',
            width: 120,
            style: { textAlign: 'left' },
            showInList: true,
            sortable: true,
            sortOrder: ''
        },
        {
            displayOrder: 13,
            headerName: window.translate('Quote Type'),
            field: 'quoteTypeName',
            type: 'text',
            showInList: true,
            sortable: true,
            sortOrder: '',
            width: 110
        },
        {
            displayOrder: 14,
            headerName: window.translate('View'),
            field: 'pdfUrl',
            type: 'custom',
            customType: 'pdf',
            width: 50,
            showInList: true,
            sortable: false,
            sortOrder: ''
        },
        {
            displayOrder: 15,
            headerName: window.translate('Status'),
            field: 'statusName',
            fieldDisabled: 'bookDisabled',
            type: 'custom',
            component: (
                <BookButton
                    campaign={campaign}
                    readOnly={readOnly}
                    getQuotes={getQuotes}
                    refreshCampaign={refreshCampaign}
                    creditStatusWorkflowId={creditStatusWorkflowId}
                    preBookingWorkflowId={preBookingWorkflowId}
                    bookingWorkflowId={bookingWorkflowId}
                    discountApprovalWorkflowId={discountApprovalWorkflowId}
                    isCampaignModified={isCampaignModified}
                    updateCampaign={updateCampaign}
                    updateActiveRequest={updateActiveRequest}
                    campaignApprovalTeam={campaignApprovalTeam}
                    businessType={businessType}
                    validateBooking={validateBooking}
                    billingAccountCreditDetails={billingAccountCreditDetails}
                    isCampaignBurst={isCampaignBurst}
                    activeRequest={activeRequest}
                    discountRequest={discountRequest}
                    dealDiscounts={dealDiscounts}
                    onDiscountRequestApproval={onDiscountRequestApproval}
                    isUsingDynamicWorkflow={isUsingDynamicWorkflow}
                    valuePotRequest={valuePotRequest}
                    valuePotApprovalWorkflowId={valuePotApprovalWorkflowId}
                />
            ),
            style: { width: 113 },
            customType: 'component',
            showInList: true,
            sortable: false,
            sortOrder: '',
            isStatus: true
        },
        {
            displayOrder: 16,
            headerName: window.translate('Approval'),
            field: 'approvalStatus',
            type: (preBookingWorkflowId || bookingWorkflowId) && !isCampaignBurst ? 'custom' : 'hidden',
            component: (
                <ApprovalStatus
                    refreshCampaign={refreshCampaign}
                    activeBookingRequest={activeBookingRequest}
                    canApprove={canApprove}
                />
            ),
            style: { width: 113 },
            customType: 'component',
            showInList: true,
            sortable: false,
            sortOrder: ''
        }
    ];

    columns.push();

    return columns;
};

export default QuotesGridColumnDefinitions;
